/* template */
export const tempLogout = /*html*/ `
<div id="page-logout">
    <div id="content">
        <div class="logo">
            <img src="https://cdn.jsdelivr.net/npm/slimsdk/dist/assets/icon/icon-02.png">
        </div>
        <button id="btn-login" class="lg">เข้าระบบอีกครั้ง</button>
    </div>
    <!-- loader -->
    <div id="loader"></div>
</div>
<style>
#app:has(#page-logout) {
    padding: 0;
}
#page-logout {
    width: 100%;
    height: 100%;
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url('https://cdn.jsdelivr.net/npm/slimsdk/dist/assets/bg/bg-01.jpg');
}
#page-logout #content {
    text-align: center;
    animation: fadeIn 0.4s;
}
#page-logout #content .logo {
    margin: auto;
    width: 150px;
    height: 150px;
    margin-bottom: 20px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
#page-logout #content .logo img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
#page-logout #content #btn-login {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px,
        rgba(0, 0, 0, 0.23) 0px 3px 6px;
}
#page-logout #loader {
    position: absolute;
    margin-bottom: 64px;
    width: 155px;
    height: 155px;
    border-radius: 50%;
    border: 5px solid #E5E7EB;
    border-color: #E5E7EB #06B6D4 #E5E7EB #06B6D4;
    animation: spin 2s linear infinite;
}
</style>
`;